// ABOUTME: React Query hook for user profile data, replacing duplicated getProfile() calls
// ABOUTME: Provides cached profile with automatic deduplication across components

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { getProfile } from '@/lib/supabase/profiles';
import { Profile } from '@/__generated__/database.types';

export function useProfile() {
  const { user } = useAuth();

  const { data: profile, isLoading, error } = useQuery<Profile | null>({
    queryKey: ['profile', user?.id],
    queryFn: () => user?.id ? getProfile(user.id) : Promise.resolve(null),
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes — profile rarely changes mid-session
  });

  return { profile: profile ?? null, isLoading, error };
}
